module.exports = __webpack_public_path__ + "static/media/poultry-farm.d9b4edc9.PNG";